import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { organizationApi } from '../../services/api';
import './Organization.css';

export const OrganizationSetup: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const { refreshUser, refreshOrganization } = useAuth();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { organization } = await organizationApi.create(formData);
      await refreshUser();
      await refreshOrganization();
      // Redirect to main app
      window.location.href = '/app';
    } catch (error: any) {
      setError(error.response?.data?.error || 'Failed to create organization. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="org-setup-container">
      <div className="org-setup-card">        
        <div className="org-setup-header">
          <h2>
            <span style={{color: 'var(--bg-color)'}}>todo</span>
            <span style={{color: 'var(--bg-color)', opacity: 0.8}}>bananowe.it</span>
          </h2>
          <p>Create your organization to get started</p>
        </div>

        <form onSubmit={handleSubmit} className="org-setup-form">
          {error && (
            <div className="org-error">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="name">Organization Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your organization name"
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe your organization (optional)"
              disabled={isLoading}
              rows={3}
            />
          </div>

          <button 
            type="submit" 
            className="org-submit-btn"
            disabled={isLoading || !formData.name.trim()}
          >
            {isLoading ? 'Creating Organization...' : 'Create Organization'}
          </button>
        </form>

        <div className="org-setup-info">
          <h3>What happens next?</h3>
          <ul>
            <li>You'll become the owner of this organization</li>
            <li>You can invite team members to collaborate</li>
            <li>All tasks will be organized within this workspace</li>
            <li>You can manage permissions and settings</li>
          </ul>
        </div>
      </div>
    </div>
  );
}; 